export type ExperimentVersionType = 'fullsolution' | 'searchbrowse' | 'sfcc' | undefined;

export enum ExperimentVersion {
    FULL_SOLUTION = 'fullsolution',
    SEARCH_BROWSE = 'searchbrowse',
    SFCC = 'sfcc',
}

export enum ExperimentCookies {
    EXPERIMENT_VERSION = 'x-petm-experiment-version',
}
